import { CommonModule } from '@angular/common';
import { CarouselModule } from 'primeng/carousel';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';
import { FlexLayoutModule } from '@angular/flex-layout';
import { Component, ViewEncapsulation } from '@angular/core';
import { PopupComponent } from 'app/components/popup/popup.component';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';
import { CalendarViewComponent } from 'app/components/calendar-view/calendar-view.component';
import { CalendarViewMobileComponent } from 'app/components/calendar-view-mobile/calendar-view-mobile.component';
import { ApplicationService } from 'app/services/application.service';
import { LoaderComponent } from 'app/components/loader/loader.component';
import { LndpGalleryDesktopComponent } from 'app/components/lndp-gallery-desktop/lndp-gallery-desktop.component';
import { LndpGalleryMobileComponent } from 'app/components/lndp-gallery-mobile/lndp-gallery-mobile.component';
import { CalendarScrollToTopComponent } from 'app/components/calendar-scroll-to-top/calendar-scroll-to-top.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-cgc-development-programme',
    templateUrl: './cgc-development-programme.component.html',
    styleUrls: ['./cgc-development-programme.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        CommonModule,
        MatCardModule,
        CarouselModule,
        FooterComponent,
        HeaderComponent,
        TranslateModule,
        FlexLayoutModule,
        CalendarViewComponent,
        CalendarViewMobileComponent,
        LoaderComponent,
        LndpGalleryDesktopComponent,
        LndpGalleryMobileComponent,
        CalendarScrollToTopComponent,
    ],
    standalone: true,
})
export class CgcDevelopmentProgrammeComponent {
    products: any = [
        {
            title: 'CGC_DEV_PROG_PAGE.FINANCIAL_ADVISORY',
            description: 'CGC_DEV_PROG_PAGE.FINANCIAL_ADVISORY_DESCRIPTION',
            description_1: 'CGC_DEV_PROG_PAGE.FINANCIAL_ADVISORY_DESCRIPTION_1',
            otherDescription: {
                other_1:
                    'CGC_DEV_PROG_PAGE.FINANCIAL_ADVISORY_DESCRIPTION_OTHER_1',
                other_2:
                    'CGC_DEV_PROG_PAGE.FINANCIAL_ADVISORY_DESCRIPTION_OTHER_2',
                other_3:
                    'CGC_DEV_PROG_PAGE.FINANCIAL_ADVISORY_DESCRIPTION_OTHER_3',
            },
            faq: {
                header: 'CGC_DEV_PROG_PAGE.READ_FA_FAQ',
                data: {},
            },
            video: 'https://www.youtube.com/embed/q3dGrMl1oQQ',
            miniTitle: 'CGC_DEV_PROG_PAGE.FINANCIAL_ADVISORY_MINI_TITLE',
            registerUrl:
                'https://www.surveymonkey.com/r/KhidmatNasihatKewangan',
            POPUP_GA: {
                event: 'signup_financial_advisory_button_dev_prog_click',
                label: 'Sign Up Financial Advisory Button Click',
            },
        },
        {
            title: 'CGC_DEV_PROG_PAGE.ADVISORY_WORKSHOPS',
            description: 'CGC_DEV_PROG_PAGE.ADVISORY_WORKSHOP_DESCRIPTION',
            description_1: 'CGC_DEV_PROG_PAGE.ADVISORY_WORKSHOP_DESCRIPTION_1',
            otherDescription: {
                other_1:
                    'CGC_DEV_PROG_PAGE.ADVISORY_WORKSHOP_DESCRIPTION_OTHER_1',
                other_2:
                    'CGC_DEV_PROG_PAGE.ADVISORY_WORKSHOP_DESCRIPTION_OTHER_2',
            },
            description_2: 'CGC_DEV_PROG_PAGE.ADVISORY_WORKSHOP_DESCRIPTION_2',
            topics: {
                header: 'CGC_DEV_PROG_PAGE.AW_TOPICS',
                data: [
                    'CGC_DEV_PROG_PAGE.BUSINESS_PLAN',
                    'CGC_DEV_PROG_PAGE.FINANCIAL_LITERACY',
                    'CGC_DEV_PROG_PAGE.MARKETING_AND_SALES',
                    'CGC_DEV_PROG_PAGE.HALAL',
                    'COMMON.ESG',
                    'CGC_DEV_PROG_PAGE.BUSINESS_EXPANSION',
                ],
            },
            faq: {
                header: 'CGC_DEV_PROG_PAGE.READ_AW_FAQ',
                data: {},
            },
            video: 'https://www.youtube.com/embed/HtfdGEIDbwI',
            miniTitle: 'CGC_DEV_PROG_PAGE.ADVISORY_WORKSHOP_MINI_TITLE',
            registerUrl: 'https://www.surveymonkey.com/r/CGCDPRegistrationForm',
            POPUP_GA: {
                event: 'signup_advisory_workshop_button_dev_prog_click',
                label: 'Sign Up Advisory Workshop Button Click',
            },
        },
        {
            title: 'CGC_DEV_PROG_PAGE.ACCESS_NEW_MARKETS',
            description: 'CGC_DEV_PROG_PAGE.ACCESS_NEW_MARKETS_DESCRIPTION',
            description_1: 'CGC_DEV_PROG_PAGE.ACCESS_NEW_MARKETS_DESCRIPTION_1',
            description_2: 'CGC_DEV_PROG_PAGE.ACCESS_NEW_MARKETS_DESCRIPTION_2',
            faq: {
                header: 'CGC_DEV_PROG_PAGE.READ_ANM_FAQ',
                data: {},
            },
            video: 'https://www.youtube.com/embed/0hDdeNg8CAo',
            miniTitle: 'CGC_DEV_PROG_PAGE.ACCESS_NEW_MARKETS_MINI_TITLE',
            registerUrl: 'https://www.surveymonkey.com/r/CGCDPRegistrationForm',
            POPUP_GA: {
                event: 'signup_access_new_markets_button_dev_prog_click',
                label: 'Sign Up Access New Markets Button Click',
            },
        },
        {
            title: 'CGC_DEV_PROG_PAGE.NETWORKING_SESSION',
            description: 'CGC_DEV_PROG_PAGE.NETWORKING_SESSION_DESCRIPTION',
            description_1: 'CGC_DEV_PROG_PAGE.NETWORKING_SESSION_DESCRIPTION_1',
            description_2: 'CGC_DEV_PROG_PAGE.NETWORKING_SESSION_DESCRIPTION_2',
            otherDescription: {
                other_1:
                    'CGC_DEV_PROG_PAGE.NETWORKING_SESSION_DESCRIPTION_OTHER_1',
                other_2:
                    'CGC_DEV_PROG_PAGE.NETWORKING_SESSION_DESCRIPTION_OTHER_2',
                other_3:
                    'CGC_DEV_PROG_PAGE.NETWORKING_SESSION_DESCRIPTION_OTHER_3',
                other_4:
                    'CGC_DEV_PROG_PAGE.NETWORKING_SESSION_DESCRIPTION_OTHER_4',
            },
            faq: {
                header: 'CGC_DEV_PROG_PAGE.READ_NS_FAQ',
                data: {},
            },
            video: 'https://www.youtube.com/embed/Xbnhr_6G6PU',
            miniTitle: 'CGC_DEV_PROG_PAGE.NETWORKING_SESSION_MINI_TITLE',
            registerUrl: 'https://www.surveymonkey.com/r/CGCDPRegistrationForm',
            POPUP_GA: {
                event: 'signup_networking_session_button_dev_prog_click',
                label: 'Sign Up Networking Session Button Click',
            },
        },
    ];

    responsiveOptions: any = [
        {
            breakpoint: '1400px',
            numVisible: 3,
            numScroll: 3,
        },
        {
            breakpoint: '1220px',
            numVisible: 2,
            numScroll: 2,
        },
        {
            breakpoint: '1100px',
            numVisible: 1,
            numScroll: 1,
        },
    ];

    calendarRes = [];
    imagesData: any = [];
    imageObjectAW: Array<any> = [];
    imageObjectANM: Array<any> = [];
    imageObjectNS: Array<any> = [];
    imageObjectFA: Array<any> = [];

    selectedLanguage: any;
    urlSafeDesktop: SafeResourceUrl | undefined;
    urlSafeMobile: SafeResourceUrl | undefined;
    link = 'https://www.youtube.com/embed/2aBRsvVB7lE';

    constructor(
        public dialog: MatDialog,
        private applicationService: ApplicationService,
        private readonly domSanitizer: DomSanitizer
    ) {
        let autoplay = '?autoplay=1&mute=1&playsinline=1';
        if (window.innerWidth >= 1024) {
            this.urlSafeDesktop =
                this.domSanitizer.bypassSecurityTrustResourceUrl(
                    this.link + autoplay
                );
            this.urlSafeMobile =
                this.domSanitizer.bypassSecurityTrustResourceUrl(this.link);
        } else {
            this.urlSafeDesktop =
                this.domSanitizer.bypassSecurityTrustResourceUrl(this.link);
            this.urlSafeMobile =
                this.domSanitizer.bypassSecurityTrustResourceUrl(
                    this.link + autoplay
                );
        }
    }

    ngOnInit() {
        this.getImages();
    }

    getImages() {
        this.applicationService.getGalleryImages().subscribe((res: any) => {
            this.imagesData = res;
            if (this.imagesData.length) {
                this.imagesData.map(function (obj) {
                    let newObj = obj;
                    obj['form_id'] = newObj['form_id'];
                    obj['image'] = newObj['filename'];
                    obj['thumbImage'] = newObj['image'];
                    obj['alt'] = '';

                    // DELETE UNNECESSARY (WILL DO MANUALLY, WILL REFACTOR)
                    let unwantedKey = [
                        'created_at',
                        'filename',
                        'id',
                        'order',
                        'updated_at',
                    ];
                    unwantedKey.forEach((key: any) => {
                        delete obj[key];
                    });

                    return obj;
                });

                // GROUPING BY FORM_ID (EVENT TYPE)
                let groupedResult: any = this.imagesData.reduce(function (
                    r,
                    a
                ) {
                    r[a.form_id] = r[a.form_id] || [];
                    r[a.form_id].push(a);
                    return r;
                },
                Object.create(null));

                for (let i = 1; i <= 4; i++) {
                    if (groupedResult[i] && groupedResult[i].length) {
                        groupedResult[i].map(function (obj) {
                            delete obj['form_id'];
                            return obj;
                        });
                    }
                }

                this.imageObjectAW = groupedResult[1] ? groupedResult[1] : [];
                this.imageObjectANM = groupedResult[3] ? groupedResult[3] : [];
                this.imageObjectNS = groupedResult[2] ? groupedResult[2] : [];
                this.imageObjectFA = groupedResult[4] ? groupedResult[4] : [];
            }
        });
    }

    openInfo(type: any, screenType: any) {
        let data;
        this.products.forEach((e: any) => {
            if (e.title == type) {
                data = e;
            }
        });
        let options = {};
        if (screenType == 'big') {
            options = {
                width: '989px',
                height: '635px',
                disableClose: true,
                panelClass: 'custom-modal-css',
                data: { from: 'lndp', type: type, data: data },
            };
        } else {
            let w = (window.innerWidth - 100).toString();
            options = {
                width: w + 'px',
                height: 'auto',
                disableClose: true,
                panelClass: 'custom-modal-css',
                data: {
                    from: 'lndp',
                    screen: screenType,
                    type: type,
                    data: data,
                },
            };
        }
        let dialogRef = this.dialog.open(PopupComponent, options);

        dialogRef.afterClosed().subscribe((result) => {});
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
    }

    findYPosition(elementName: any) {
        const note = document.getElementsByTagName(elementName)[0];
        const details = note.getBoundingClientRect();
        const initialYPosition = details.y.toString();
        const nameSet = 'YPosition-' + elementName;
        localStorage.setItem(nameSet, initialYPosition);
    }
}
